export default "__VITE_ASSET__DiFnWTcQ__"